import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MdbPopoverDirective, MdbPopoverModule } from 'mdb-angular-ui-kit/popover';
import { Subject } from 'rxjs';
import { PopoverService } from 'app/core/services/popover.service';
import { ChooseImageModalService } from 'app/core/services/choose-image-modal.service';


let id = 1;

@Component({
  selector: 'app-images-filter-popover',
  standalone: true,
  imports: [CommonModule, MdbPopoverModule],
  templateUrl: './images-filter-popover.component.html',
  styleUrl: './images-filter-popover.component.scss'
})
export class ImagesFilterPopoverComponent  implements OnInit, OnDestroy {

  @Input () type: number = 0; // 0 for 2x1, 1 for 1x1

  //   ImageUsedForOrgLogo                 ImageUsedFor = 0
  //   ImageUsedForOrgCover                ImageUsedFor = 1
  //   ImageUsedForCampaignMain            ImageUsedFor = 2
  //   ImageUsedForCampaignThumbNail       ImageUsedFor = 3
  //   ImageUsedForCampaignOption          ImageUsedFor = 4
  //   ImageUsedForCampaignOptionThumbNail ImageUsedFor = 5
  //   ImageUsedForEventImage              ImageUsedFor = 6
  //   ImageUsedForLobbySlideShow          ImageUsedFor = 7
  //   ImageUsedForSponsorImage            ImageUsedFor = 8
  //   ImageUsedForEventPageSlideShow      ImageUsedFor = 9

  public categories: any = [];
  public imageCategories: any = [
    {name:'Org Cover', type: 1},
    {name:'Campaigns', type: 2},
    {name:'Campaign Options ', type: 4},
    {name:'Events', type: 6},
    {name:'Lobby Slides', type: 7},
    {name:'Sponsors', type: 8},
    {name:'Event Page Slides', type: 9}
  ];
  public thumbnailCategories: any = [
    {name:'Org Logo', type: 0},
    // {name:'Campaign Thumbnails', type: 3},
    {name:'Campaign Option Thumbnails', type: 5},
  ];

  @ViewChild('popover') popover: MdbPopoverDirective = null;

  private _id = id++;
  get id() {
    return `ImagesPopoverFilter_${this._id}`;
  }

  public filterBtnText = 'All';
  public activeItem = 1
  public takeUntilSubject: Subject<any> = new Subject();
  

  constructor(
    private popoverService: PopoverService,
    public chooseImageModalService: ChooseImageModalService,
  ) { }

  ngOnInit(): void {
    this.chooseImageModalService.filterImages();
    this.categories = this.type === 0 ? this.imageCategories : this.thumbnailCategories;
  }

  onCategoryClick(category, activeIdx, categoryType){
    this.activeItem = activeIdx;
    this.chooseImageModalService.type = categoryType;
    this.filterBtnText = category == 'All' ? 'All' : category.name;
    this.chooseImageModalService.filterImages();
  }

  onPopoverShown(): void {
    this.popoverService.list[this.id] = this.popover;
  }

  onPopoverHidden(): void {
    delete this.popoverService.list[this.id];
  }

  ngOnDestroy(): void {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }

}
